var exports = {
  "container": "x61f99309--015f58--container",
  "image": "x61f99309--015f58--image",
  "horizontal": "x61f99309--015f58--horizontal",
  "vertical": "x61f99309--015f58--vertical",
  "square": "x61f99309--015f58--square",
  "error": "x61f99309--015f58--error",
  "loader": "x61f99309--015f58--loader",
  "gallery_item": "x61f99309--015f58--gallery_item",
};

module.exports = exports;
